import axios from "axios"
import { useEffect, useState } from "react"
import AddTopic from "./ql-widgets/addTopic";
import { toast } from "react-toastify";
import QlCategory from "./ql-widgets/qlCategory";
import RdModal from "../widgets/ratulModal/rdModal";
import MyModal from "../widgets/myModal/myModal";
import AiGenerate from "./AiGenerate";
import AddModal from "../widgets/myModal/addModal";
import QlExcel from "./qlExcel";
import './questionLibrary.css'
import TopicShimmer from "../widgets/shimmers/topicShimmer";
import { API_ENDPOINT, HEADER_TOKEN } from "../../constants/constants";
import DuplicateQuestions from "./duplicateQuestions";
import AddCategories from "./ql-widgets/addCategories";
import { activeArranger, activeTopicArranger } from "../../utils/util";
import QlQuestionBox from "./qlQuestionBox";
import AlertDialogSlide from "../widgets/ratulModal/alertDialog";

const PlusIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /><path d="M12 5v14" /></svg>
)

const ColumnSearch = ({ placeholder, onChange }) => (
    <input className="input" placeholder={placeholder} onChange={onChange} style={{ fontSize: 13, minHeight: 32, marginBottom: 10 }} />
)

const EmptyNote = ({ children }) => (
    <div className="text-muted" style={{ fontSize: 13, padding: '18px 12px', textAlign: 'center' }}>{children}</div>
)

const QuestionLibrary = () => {
    const [categories, setCategories] = useState([])
    const [isCategoriesLoaded, setIsCategoriesLoaded] = useState(false)
    const [category, setCategory] = useState("")
    const [searchCatList, setSearchCatList] = useState([])
    const [showAddCategory, setShowAddCategory] = useState(false)

    const [topics, setTopics] = useState([])
    const [isTopicsLoaded, setIsTopicsLoaded] = useState(false)
    const [topic, setTopic] = useState("")
    const [searchTopicList, setSearchTopicList] = useState([])
    const [showAddTopic, setShowAddTopic] = useState(false)

    const [questions, setQuestions] = useState([])
    const [isQnsLoaded, setIsQnsLoaded] = useState(true)
    const [qSearch, setQSearch] = useState("")
    const [showAns, setShowAns] = useState(false)
    const [cq, setCq] = useState({})
    const [dopen, setDopen] = useState(false)

    const [showModal, setShowModal] = useState(false)
    const [showAi, setShowAi] = useState(false)
    const [showExcelModal, setShowExcelModal] = useState(false)
    const [refreshT, setRefreshT] = useState(false)
    const [dqModal, setDqModal] = useState(false)
    const [dQs, setDQs] = useState([])

    useEffect(() => { loadCategories() }, [refreshT])
    useEffect(() => {
        if (category !== "") { setTopic(""); setQuestions([]); loadTopics() }
        else { setIsTopicsLoaded(true) }
    }, [category])

    function loadCategories() {
        setIsCategoriesLoaded(false)
        axios.get(API_ENDPOINT + 'sam/get-categories-all', HEADER_TOKEN).then(res => {
            setIsCategoriesLoaded(true)
            let d = res.data
            if (d.success) { setCategories(activeArranger(d.message)) }
            else { toast(d.message, { autoClose: 900, position: 'bottom-center' }) }
        })
    }
    function loadTopicQuestions(tp) {
        setIsQnsLoaded(false)
        axios.post(API_ENDPOINT + 'sam/topic-questions', { category: category, topic: tp }, HEADER_TOKEN).then(res => {
            let d = res.data
            setIsQnsLoaded(true)
            if (d.success) { setQuestions(d.message) }
            else { toast(d.message, { autoClose: 900, position: 'bottom-center' }) }
        })
    }
    const loadTopics = () => {
        setIsTopicsLoaded(false)
        axios.post(API_ENDPOINT + 'sam/get-category-topics', { category: category }, HEADER_TOKEN).then(res => {
            setIsTopicsLoaded(true)
            let d = res.data
            if (d.success) { setTopics(activeTopicArranger(d.message)) }
            else { toast(d.message, { autoClose: 900, position: 'bottom-center' }) }
        })
    }

    const onQnAdded = () => { setRefreshT(!refreshT) }
    const excelUploaded = () => { setRefreshT(!refreshT) }
    const duplicatesRemoved = () => {
        setRefreshT(!refreshT)
        toast("All duplicates removed successfully", { autoClose: 1500, position: 'bottom-center' })
    }
    const onTopicSelect = (v) => { setTopic(v); loadTopicQuestions(v) }
    const onCategorySelect = (cat) => { setCategory(cat) }

    const onCategorySearch = (e) => {
        let v = e.target.value
        setSearchCatList(v === "" ? [] : categories.filter(n => n.category.toLowerCase().includes(v.toLowerCase())))
    }
    const onTopicSearch = (e) => {
        let v = e.target.value
        setSearchTopicList(v === "" ? [] : topics.filter(n => n.topic.toLowerCase().includes(v.toLowerCase())))
    }

    const onCatStatusChanged = (event, cv, status) => {
        event.stopPropagation()
        let toupdate = status === "Active" ? "Inactive" : "Active"
        axios.post(API_ENDPOINT + 'sam/set-category-status', { category: cv, status: toupdate }, HEADER_TOKEN).then(res => {
            let d = res.data
            if (d.success) {
                let tcs = [...categories]
                tcs[tcs.findIndex(t => t.category === cv)].status = toupdate
                setCategories(activeArranger(tcs))
            } else { toast(d.message, { autoClose: 900, position: 'bottom-center' }) }
        })
    }
    const onTopicStatusChanged = (event, cv, tv, status) => {
        event.stopPropagation()
        let toupdate = status === "Active" ? "Inactive" : "Active"
        axios.post(API_ENDPOINT + 'sam/set-topic-status', { category: cv, topic: tv, status: toupdate }, HEADER_TOKEN).then(res => {
            let d = res.data
            if (d.success) {
                let tcs = [...topics]
                tcs[tcs.findIndex(t => (t.topic === tv && t.category === cv))].status = toupdate
                setTopics(activeTopicArranger(tcs))
            } else { toast(d.message, { autoClose: 900, position: 'bottom-center' }) }
        })
    }

    const catList = searchCatList.length > 0 ? searchCatList : categories
    const topicList = searchTopicList.length > 0 ? searchTopicList : topics
    const visibleQns = qSearch.trim() === ""
        ? questions
        : questions.filter(f => (f.question || '').toLowerCase().includes(qSearch.toLowerCase()))

    return (
        <div>
            <AddModal showModal={showAddTopic} title="Add Topic" setShowModal={setShowAddTopic} modalC={<AddTopic show={showAddTopic} setShow={setShowAddTopic} category={category} topics={topics} setTopics={setTopics} />} />
            <AddModal showModal={showAddCategory} title="Add Category" setShowModal={setShowAddCategory} modalC={<AddCategories show={showAddCategory} setShow={setShowAddCategory} categories={categories} setCategories={setCategories} />} />
            <RdModal onQnAdded={onQnAdded} isQL={true} questions={questions} setQuestions={setQuestions} showModal={showModal} setShowModal={setShowModal} />
            <MyModal
                showModal={showAi}
                setShowModal={setShowAi}
                title="Generate questions with AI"
                modalC={
                    <AiGenerate
                        category={category}
                        topic={topic}
                        topics={topicList}
                        setShowModal={setShowAi}
                        onAdded={() => { onQnAdded(); }}
                    />
                }
            />
                        <MyModal showModal={showExcelModal} setShowModal={setShowExcelModal} title="Import from Excel" modalC={<QlExcel topics={topics} excelUploaded={excelUploaded} showModal={showExcelModal} setShowModal={setShowExcelModal} />} />
            {dQs.length > 0 ? <MyModal showModal={dqModal} setShowModal={setDqModal} title="Clear Duplicate Questions" modalC={<DuplicateQuestions showModal={dqModal} setShowModal={setDqModal} duplicatesRemoved={duplicatesRemoved} questions={dQs} />} /> : ''}
            {!!cq ? <AlertDialogSlide isQl={true} dopen={dopen} q={cq} setDopen={setDopen} myqns={questions} setMyqns={setQuestions} questions={questions} setQuestions={setQuestions} /> : ''}

            <div style={{ display: 'grid', gridTemplateColumns: '0.9fr 0.9fr 1.2fr', gap: 18, alignItems: 'start' }}>

                {/* CATEGORIES */}
                <div style={{ background: 'var(--color-surface)', padding: 16 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                        <h4 style={{ margin: 0, flex: 1 }}>Categories</h4>
                        <button className="btn btn-primary" style={{ padding: '6px 12px', fontSize: 13 }} onClick={() => setShowAddCategory(!showAddCategory)}>
                            <PlusIcon />Add
                        </button>
                    </div>
                    <ColumnSearch placeholder="Search categories…" onChange={onCategorySearch} />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 2, maxHeight: 520, overflowY: 'auto' }}>
                        {!isCategoriesLoaded ? <TopicShimmer />
                            : catList.length > 0
                                ? catList.map((t, i) => (
                                    <QlCategory key={i}
                                        onCategorySelected={() => onCategorySelect(t.category)}
                                        onCatStatusChanged={(event) => onCatStatusChanged(event, t.category, t.status)}
                                        selected={category === t.category} value={t.category} status={t.status} />
                                ))
                                : <EmptyNote>No categories yet</EmptyNote>}
                    </div>
                    {dQs.length > 0 && (
                        <button className="btn btn-ghost" style={{ marginTop: 10, fontSize: 13 }} onClick={() => setDqModal(!dqModal)}>
                            {`+${dQs.length} questions have duplicates`}
                        </button>
                    )}
                </div>

                {/* TOPICS */}
                <div style={{ background: 'var(--color-surface)', padding: 16 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 10, letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--color-accent)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {category === "" ? "No category selected" : category}
                            </div>
                            <h4 style={{ margin: '2px 0 0' }}>Topics</h4>
                        </div>
                        <button className="btn btn-primary" style={{ padding: '6px 12px', fontSize: 13 }} onClick={() => setShowAddTopic(!showAddTopic)}>
                            <PlusIcon />Add
                        </button>
                    </div>
                    <ColumnSearch placeholder="Search topics…" onChange={onTopicSearch} />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 2, maxHeight: 400, overflowY: 'auto' }}>
                        {!isTopicsLoaded ? <TopicShimmer />
                            : topicList.length > 0
                                ? topicList.map((t, i) => (
                                    <QlCategory key={i}
                                        onCategorySelected={() => onTopicSelect(t.topic)}
                                        onCatStatusChanged={(event) => onTopicStatusChanged(event, t.category, t.topic, t.status)}
                                        selected={topic === t.topic} value={t.topic} status={t.status} />
                                ))
                                : <EmptyNote>{category === "" ? "Select a category to see topics" : `No topics for ${category}`}</EmptyNote>}
                    </div>
                    <hr className="hr" />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <button className="btn btn-secondary" style={{ justifyContent: 'flex-start', gap: 10 }} onClick={() => setShowExcelModal(!showExcelModal)}>
                            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z" /><path d="M14 2v4a2 2 0 0 0 2 2h4" /><path d="M8 13h2" /><path d="M14 13h2" /></svg>
                            Upload questions from Excel
                        </button>
                        <button className="btn btn-secondary" style={{ justifyContent: 'flex-start', gap: 10 }} onClick={() => setShowModal(!showModal)}>
                            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><path d="M12 17h.01" /></svg>
                            Add question manually
                        </button>
                        <button
                            className="btn btn-primary"
                            style={{ justifyContent: 'flex-start', gap: 10 }}
                            onClick={() => setShowAi(true)}
                            disabled={category === ""}
                            title={category === "" ? "Select a category first" : "Generate questions from your own material"}
                        >
                            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l1.9 4.6L18.5 9.5l-4.6 1.9L12 16l-1.9-4.6L5.5 9.5l4.6-1.9L12 3z" /><path d="M18 15l.9 2.1L21 18l-2.1.9L18 21l-.9-2.1L15 18l2.1-.9L18 15z" /></svg>
                            Generate with AI
                        </button>
                    </div>
                </div>

                {/* QUESTIONS */}
                <div style={{ background: 'var(--color-surface)', padding: 16 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 10, letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--color-accent)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {topic === "" ? "No topic selected" : topic}
                            </div>
                            <h4 style={{ margin: '2px 0 0' }}>Questions</h4>
                        </div>
                        <span className="tag tag-neutral">{visibleQns.length} shown</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                        <input className="input" placeholder="Search questions…" value={qSearch} onChange={e => setQSearch(e.target.value)} style={{ fontSize: 13, minHeight: 32 }} />
                        <label className="radio" style={{ flex: 'none', fontSize: 13, whiteSpace: 'nowrap' }}>
                            <input type="checkbox" checked={showAns} onChange={() => setShowAns(!showAns)} />
                            <span className="dot" style={{ borderRadius: 0 }}></span>
                            Show answer
                        </label>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxHeight: 620, overflowY: 'auto' }}>
                        {!isQnsLoaded ? <EmptyNote>Loading questions…</EmptyNote>
                            : topic === "" ? <EmptyNote>Select a topic to see its questions</EmptyNote>
                                : visibleQns.length > 0
                                    ? visibleQns.map((q, i) => (
                                        <QlQuestionBox key={q._id || i} i={i} onDelete={() => { setCq(q); setDopen(!dopen) }}
                                            onEdited={(qf, id) => {
                                                let qss = [...questions]
                                                const idx = qss.findIndex(x => x._id === id)
                                                if (idx >= 0) qss.splice(idx, 1, { _id: id, ...qf })
                                                setQuestions(qss)
                                            }}
                                            q={q} showAns={showAns} />
                                    ))
                                    : <EmptyNote>No questions yet</EmptyNote>}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default QuestionLibrary
